
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

// Component
import ContentScrollManager from '@/components/common/ContentScrollManager.vue';
import Navbar from '@/components/navbar/NavbarNew.vue';
import ExtendedSidebar from '@/components/sidebar/ExtendedSidebar.vue';

import Breadcrumbs from '@/components/breadcrumbs/BreadcrumbsNew.vue';
import { PortalTarget } from 'portal-vue';

// Interface
import { User, Company } from '@/interface';
import SubscriptionBasicInfoModal from '@/components/payment/SubscriptionBasicInfoModal.vue';
import Roles from '@/entities/Roles';

@Component({
	components: {
		ExtendedSidebar,
		SubscriptionBasicInfoModal,
		Navbar,
		ContentScrollManager,
		Breadcrumbs,
		PortalTarget,
	},
})
export default class Layout extends Vue {
	@Prop({ type: Boolean, required: true }) readonly authenticated!: boolean;
	@Prop({ type: Object, required: true }) readonly currentUser!: User;
	@Prop({ type: Object, default: undefined }) readonly company?: Company;

	sidebarOpen: boolean = false;
	subscriptionInfoShown: boolean = true;
	// State
	isOpen: boolean = true;
	clients: any[] = [];
	confirm = {
		show: false,
		response: null,
	};

	containerClasses: string = 'h-full mx-auto px-4 sm:px-6 md:px-8';

	get isSubscriptionInfoModalShown(): boolean {
		if (this.currentUser.role !== Roles.ADMIN) {
			return false;
		}

		return (
			this.subscriptionInfoShown &&
			!this.currentUser.admin.subscription_info_showed
		);
	}

	get innerLayoutClasses(): Record<string, boolean> {
		return {
			//@ts-ignore
			[this.containerClasses]: !this.$route.meta.customLayout,
		};
	}

	// get isManagersPage(): boolean {
	//   return /^\/managers/.test(this.$route.path);
	// }

	get isResourcesPage(): boolean {
		const isNewPath = this.$route.path.includes('/company_database');
		return isNewPath;
	}

	get isProjectPage(): boolean {
		const pattern = /^\/projects/;
		return pattern.test(this.$route.path);
	}

	get companyId(): string {
		if (!this.company) {
			return '';
		}
		return this.company.id;
	}
	get isResourcesOboarded() {
		return (
			(this.currentUser.role === Roles.CONTRACTOR &&
				this.currentUser.profile_completed) ||
			this.currentUser.role === Roles.ADMIN ||
			this.currentUser.role === Roles.MANAGER
		);
	}
	@Watch('$route')
	onRouterUpdate() {
		this.subscriptionInfoShown = false;

		if (this.sidebarOpen) {
			this.sidebarOpen = false;
		}
	}

	hideSubscriptionInfo(): void {
		this.subscriptionInfoShown = false;
	}

	openSidebar(): void {
		this.sidebarOpen = true;
	}

	closeSidebar(): void {
		this.sidebarOpen = false;
	}
}
